<main>
  @if (!comments || !comments.length) {
    <p class="empty">No comments on this render</p>
  }
  @else {
    <div class="comment-list">
    @for (comment of comments; track comment) {
      <section>
        <p>{{comment.text}}</p>
        <div class="bottom-bar">
          <p class="created-by">{{comment.author}}</p>
          <p class="date">{{comment.created | date:'medium'}}</p>
        </div>
      </section>
    }
    </div>
  }
  <div class="bottom">
    <textarea
        pInputTextarea
        placeholder="Enter your notes here..."
        [autoResize]="true"
        [(ngModel)]="comment">
      >
    </textarea>
    <p-button
      label="Add Comment"
      icon="pi fi fi-rr-messages"
      severity="primary"
      (onClick)="addComment()"
    />
  </div>
</main>
